/**
 * WordPress dependencies
 */
import { TabPanel } from '@wordpress/components';

/**
 * Internal dependencies
 */
import FeatureComparisonTable from './featureComparisonTable';

export default function FreeVsPro() {
  return (
    <div className="rv_dash-free_vs_pro-page">
        <div className='rv_dash-fp-tabs'>
            <TabPanel
                className="rv_dash-fp-tab-panel"
                activeClass="rv-active-tab"
                tabs={ [
                    {
                        name: 'tableBuilder',
                        title: 'Table Builder',
                        className: 'rv-table-builder-block',
                        content: <FeatureComparisonTable blockType='tableBuilder' />
                    },
					{
                        name: 'pricingTable',
                        title: 'Pricing Table',
                        className: 'rv-pricing-table-block',
                        content: <FeatureComparisonTable blockType='pricingTable' />
                    },
                    {
                        name: 'prosAndCons',
                        title: 'Pros and Cons',
                        className: 'rv-pros-and-cons-block',
                        content: <FeatureComparisonTable  blockType='prosAndCons' />
                    }
                ] }
            >
                { ( tab ) => ( <div className='rv_dash-fp-content'>{tab.content}</div> ) }
            </TabPanel>
        </div>
    </div>
  )
}
